import getReadOnlyStatus from './read-only';

export default {
  getReadOnlyStatus,
};
